import { render } from "./FundContent.vue?vue&type=template&id=70242bab&scoped=true"
import script from "./FundContent.vue?vue&type=script&lang=js"
export * from "./FundContent.vue?vue&type=script&lang=js"

import "./FundContent.vue?vue&type=style&index=0&id=70242bab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70242bab"]])

export default __exports__